import { createContext } from "react";
const WebMyAccountProvider = createContext();
export default WebMyAccountProvider;
